import { Component, OnInit } from '@angular/core';
import { AppManagementService } from '../../services/app-management.service';
import { CustomService } from '../../services/custom.service';

@Component({
  selector: 'app-upload-view',
  templateUrl: './upload-view.component.html',
  styleUrls: ['./upload-view.component.scss']
})

export class UploadViewComponent implements OnInit {
  pageDesignFlag: boolean =false;
  // PAGE DESIGN OBJECT
  pageDesign: any;
  customLoader: any;
  
  // FLAG FOR VIEW SWITCH BETWEEN CUSTOM AND TEMPLATE DESIGN
  customDesign:boolean = false;

  constructor(
    public appDesignService: AppManagementService,
    public customService: CustomService) {
      appDesignService.setBackClick(true);
    }

  ngOnInit() {
    
    this.pageDesign = this.appDesignService.getPageDesign();
    
    //RESETTING SURVEY STARTED STATUS
    this.customService.surveyStarted = false;

    if(this.pageDesign!=undefined){
      this.pageDesignFlag = true;
      //SENDING PAGE VIEW FOR GA
      this.customService.sendPageViewUpdate(this.pageDesign.name);
      
      this.pageDesign["style"] = this.appDesignService.applyElementStyle(this.pageDesign);
      
      //NORMAL ELEMENT FLOWS STACK LIST
      if(this.pageDesign.element_flow!=undefined){
        // ADDING STYLE TO EACH ELEMENT IN THE PAGE
        for (var t = 0; t < this.pageDesign.element_flow.length; t++) {
          this.pageDesign.element_flow[t]["style"] = this.appDesignService.applyElementStyle(this.pageDesign.element_flow[t]);
        }
      } 
      this.customLoader = this.customService.getCustomLoader();
    
      setTimeout(() => { this.updateIframeHeight(); }, 300);
      this.captureImageLoadEvent();
    }
    else{
      this.appDesignService.redirectAppToBase();
    }
  }

  captureImageLoadEvent(){
    var imgs = document.querySelectorAll('img')
    for(var im=0;im<imgs.length;im++){
      if (imgs[im].complete) {
        this.updateIframeHeight()
      } else {
        imgs[im].addEventListener('load', this.updateIframeHeight)
        imgs[im].addEventListener('error', function() { })
      }
    } 
  }

  
  ngAfterViewChecked() { this.updateIframeHeight(); }

  ngDoCheck() { this.updateIframeHeight(); }

  ngAfterContentChecked() { this.updateIframeHeight(); }
  
  updateIframeHeight(){
    if(this.pageDesign!=undefined){
      var ele = document.getElementById(this.pageDesign.name);
      if(ele!=null && ele!=undefined){
        this.appDesignService.sentHeight(ele.offsetHeight);
      }
    }
  }

}
